import { render, staticRenderFns } from "./cookie.vue?vue&type=template&id=5456c485&scoped=true&"
import script from "./cookie.vue?vue&type=script&lang=js&"
export * from "./cookie.vue?vue&type=script&lang=js&"
import style0 from "./cookie.vue?vue&type=style&index=0&id=5456c485&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5456c485",
  null
  
)

export default component.exports